export const AUTH_ERROR_CODES = Object.freeze({
    ACCESS_TOKEN_EXPIRED: "access_token_expired",
    SESSION_REVOKED: "session_revoked",
});
